
import { useCollectionTracked } from "presentation/store/Collection/CollectionProvider";
import { SliderPanel } from "veronica-ui-component/dist/component/core";
import { CollectionDtlRightPanel } from "./CollectionDtlRightPanel";
import CollectionHdrTablePanel from "./CollectionHdrTablePanel";

export const CollectionRightPanel: React.FC = () => {
    const [collectionState] = useCollectionTracked();
    const { isShowDetailPanel } = collectionState;

    return <>
        <div className={`main-comp-wrapper${(isShowDetailPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <SliderPanel
                isOpen={true}
                leftSectionWidth={isShowDetailPanel ? '30%' : '100%'}
                rightSectionWidth={isShowDetailPanel ? '70%' : '0%'}
                draggable={false}
                leftChildren={<CollectionHdrTablePanel />}
                rightChildren={<CollectionDtlRightPanel />}
            />
        </div>
    </>
}